<template>
  <div>
    <input id="file" type="file" multiple />
  </div>
</template>
<script>
import Vue from 'vue';

import VueCompositionAPI, {
  defineComponent,
  reactive,
  computed,
  onMounted,
  toRefs,
  ref,
  watch
} from '@vue/composition-api';

Vue.use(VueCompositionAPI);
// import { uploadFile, STORAGE, getDownloadURL } from '../services/storage';
import createFilePond from './filepond';

import Drive from './drive';

const drive = new Drive();

export default defineComponent({
  name: 'ImageUpload',

  props: {
    metadata: {},
    required: {
      type: Boolean,
      default: true
    },
    user: {
      type: String,
      required: true
    },
    folderId: {
      type: [String, null],
      default: null
    },
    instantUpload: {
      type: Boolean,
      default: true
    },
    maxFiles: {
      type: Number,
      default: null
    },
    allowRevert: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    let pond;

    const files = ref([]);
    const valid = ref(true);

    const total = ref(0);
    const uploaded = ref(0);
    const uploadErrors = ref(0);
    const uploading = ref(false);

    const data = reactive({
      errorBag: { required: { valid: true, detail: '' } },
      resetForm: false
    });

    const ids = computed(() => files.value.map(e => e.id));

    watch(
      files,
      val => {
        context.emit('update:files', val);
      },
      { immediate: true }
    );
    watch(
      ids,
      val => {
        context.emit('update:ids', val);
      },
      { immediate: true }
    );
    watch(
      valid,
      val => {
        context.emit('input', val);
      },
      { immediate: true }
    );
    watch(uploading, val => {
      context.emit('update:uploading', val);
    });
    /* ----------- Validation -----------  */
    const resetValidation = () => {
      valid.value = true;
      Object.keys(data.errorBag).forEach(key => {
        data.errorBag[key].valid = true;
      });

      context.emit('input', valid.value);
    };

    const validate = () => {
      resetValidation();

      if (props.required) {
        if (!files.value.length) {
          data.errorBag.required = reactive({
            valid: false,
            detail: 'At least one image is required'
          });
          valid.value = false;
        }
      }

      context.emit('input', valid.value);
    };

    const clearFiles = async () => {
      data.resetForm = true;
      await pond.removeFiles();
      setTimeout(() => {
        data.resetForm = false;
      }, 3000);
      resetValidation();
    };

    const updateLoading = () => {
      uploading.value = pond.getFiles().filter(x => x.status !== 5).length !== 0;
    };

    const addTotal = () => {
      updateLoading();
      total.value += 1;
      context.emit('update:total', total.value);
    };
    const addUploaded = () => {
      uploaded.value += 1;
      context.emit('update:uploaded', uploaded.value);
    };
    const addError = () => {
      uploadErrors.value += 1;
      context.emit('update:uploadErrors', uploadErrors.value);
    };

    /* ----------- Upload -----------  */
    // uplaod image to cloud storage
    const onProcessFile = async ({ file }) => {
      const { path, metadata } = await drive.uploadFile({
        file,
        user: props.user,
        metadata: props.metadata
      });
      const url = await drive.getDownloadURL(path);

      const fileInfo = {
        name: `${file.name}`,
        path,
        url,
        metadata,
        size: file.size
      };

      files.value.push(fileInfo);

      context.emit('upload', fileInfo);
      addUploaded();

      // data.errorBag.required.valid = true;
    };
    // remove image

    onMounted(() => {
      pond = createFilePond({
        el: '#file',
        onProcess: onProcessFile,
        onaddfilestart: addTotal,
        onremovefile: () => {
          total.value -= 1;
          updateLoading();
          context.emit('update:total', total.value);
        },
        onerror: addError,
        onprocessfiles: () => {
          context.emit('update:uploadCompleted', true);
        },
        onprocessfilerevert: () => {
          context.emit('revert');
        },
        instantUpload: props.instantUpload,
        maxFiles: props.maxFiles,
        allowRevert: props.allowRevert,
        onprocessfile: () => {
          updateLoading();
        }
      });
    });

    const startUpload = () => {
      pond.processFiles();
    };

    return {
      validate,
      resetValidation,
      clearFiles,
      files,
      valid,
      total,
      uploaded,
      uploadErrors,
      startUpload,
      ...toRefs(data)
    };
  }
});
</script>

<style>
</style>
